import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import Select from 'react-select-virtualized';
import { scrollToTop } from '../../utils/smartutils';

class SelectField extends PureComponent {
  customStyles = {
    control: () => ({
      boxAlign: 'center',
      alignItems: 'center',
      cursor: 'default',
      display: 'flex',
      flexWrap: 'wrap',
      boxPack: 'justify',
      justifyContent: 'space-between',
      minHeight: 30,
      outline: 0,
      position: 'relative',
      transition: 'all 100ms',
      boxSizing: 'border-box',
    }),

    valueContainer: () => ({
      boxAlign: 'center',
      alignItems: 'center',
      display: 'flex',
      flex: 1,
      flexWrap: 'wrap',
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 8,
      paddingRight: 8,
      position: 'relative',
      overflow: 'hidden',
      boxSizing: 'border-box',
    }),

    input: () => ({
      boxSizing: 'content-box',
      width: 2,
      background: 'rgba(0,0,0,0) none repeat scroll 0px center',
      border: '0px none',
      fontSize: 'inherit',
      opacity: 1,
      outline: 'currentcolor none 0px',
      padding: 0,
      height: 30,
    }),
  };

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    isMulti: PropTypes.bool,
    isDisabled: PropTypes.bool,
    closeMenuOnSelect: PropTypes.bool,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.number,
        label: PropTypes.string,
      })
    ),
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        value: PropTypes.number,
        label: PropTypes.string,
      }),
    ]).isRequired,
    t: PropTypes.func.isRequired,
    isClearable: PropTypes.bool,
  };

  static defaultProps = {
    placeholder: '',
    options: [],
    isMulti: false,
    closeMenuOnSelect: true,
    isDisabled: false,
    isClearable: false,
  };

  setValueIsMultiOptions = (selectedOption) => {
    const { onChange, value } = this.props;
    let updatedValue;
    if (selectedOption && selectedOption.length) {
      updatedValue = selectedOption;
    } else if (selectedOption === null) {
      updatedValue = selectedOption;
    } else if (selectedOption.length === 0) {
      updatedValue = null;
    } else {
      updatedValue = [selectedOption, ...value];
    }
    onChange(updatedValue);
  };

  handleChange = (selectedOption) => {
    const { onChange, isMulti } = this.props;
    if (isMulti) {
      this.setValueIsMultiOptions(selectedOption);
    } else {
      onChange(selectedOption);
    }
  };

  render() {
    const {
      value,
      name,
      placeholder,
      options,
      isMulti,
      closeMenuOnSelect,
      isDisabled,
      t,
      isClearable,
    } = this.props;
    return (
      <Select
        name={name}
        value={value}
        isClearable={isClearable}
        onChange={this.handleChange}
        options={options}
        clearable={false}
        isMulti={isMulti}
        closeMenuOnSelect={closeMenuOnSelect}
        className="react-select"
        classNamePrefix="react-select"
        styles={this.customStyles}
        placeholder={placeholder}
        isDisabled={isDisabled}
        noOptionsMessage={() => t('general.no-options')}
      />
    );
  }
}

const renderSelectFieldVirtualized = (props) => {
  const {
    input,
    meta,
    options,
    placeholder,
    isMulti,
    isDisabled,
    closeMenuOnSelect,
    t,
    isClearable,
  } = props;

  return (
    <div className="form__form-group-input-wrap form__form-group-input-wrap--error-above">
      <SelectField
        {...input}
        options={options}
        placeholder={placeholder}
        isMulti={isMulti}
        isDisabled={isDisabled}
        closeMenuOnSelect={closeMenuOnSelect}
        t={t}
        isClearable={isClearable}
      />
      {(meta.touched && meta.error) || (meta.submitFailed && meta.error) ? (
        <span className="form__form-group-error">
          {meta.error} {scrollToTop()}
        </span>
      ) : null}
    </div>
  );
};

renderSelectFieldVirtualized.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    name: PropTypes.string,
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
    })
  ),
  isMulti: PropTypes.bool,
  isDisabled: PropTypes.bool,
  closeMenuOnSelect: PropTypes.bool,
  placeholder: PropTypes.string,
  t: PropTypes.func.isRequired,
  isClearable: PropTypes.bool,
};

renderSelectFieldVirtualized.defaultProps = {
  meta: null,
  options: [],
  placeholder: '',
  isMulti: false,
  closeMenuOnSelect: true,
  isDisabled: false,
  isClearable: false,
};

export default withTranslation('common')(renderSelectFieldVirtualized);
